module.exports = __webpack_public_path__ + "img/Dantam Hair 48.2ce9f2a5.jpg";